module.exports = __webpack_public_path__ + "img/bg-home-woman.f416ebb1.png";